import { Component, Input } from '@angular/core';

import { Usuario } from '../usuario';

@Component({
    selector: 'sgt-usuario-permissao',
    templateUrl: './usuario-permissao.component.html',
    styleUrls: ['./usuario-permissao.component.less']
})
export class UsuarioPermissaoComponent {
    @Input() entity: Usuario;
    @Input() isPerfilRepresentante: boolean;
}
